export const LOCK_NODE_EDITOR_CLASSNAME = "lock-on-focus" as const;
export const LOCK_SCHEMA_EDITOR_CLASSNAME =
  "lock-on-focus-schema-editor" as const;
